"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LauncherAR = void 0;
class LauncherAR {
    constructor() {
        this._opt = {
            anchor: "horizontal_vertical"
        };
    }
    /**
     * Initialise and launch with a single function call. this is mostly for convenience.
     * Use .init() and .start() separately for fine-grained control
     */
    launch() {
        return new Promise((accept, reject) => {
            this.init().then((value) => {
                value.start();
                return accept();
            }).catch(reject);
        });
    }
    /**
     * AR Options used for launching AR
     */
    get options() {
        return this._opt;
    }
}
exports.LauncherAR = LauncherAR;
